import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { MAP__tools_by_name } from '@shared/types/types';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { GENERATION_TOOL__general__image_aspect_ratio } from '../general/GENERATION_TOOL__general__image_aspect_ratio';
import { GENERATION_TOOL__vision__color_map } from './GENERATION_TOOL__vision__color_map';

export function FN_GENERATION_TOOL__create_map__vision__color_map() {
  /*
   *
   */

  /*
   *
   */

  let out: MAP__tools_by_name = new MAP__serializable();

  DTO__generation_tool.CREATE_TO_MAP(out, () => GENERATION_TOOL__general__image_aspect_ratio(ENUM__image_asset_category.COLOR_MAP));
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__vision__color_map);

  return out;
}
